import React, { useState, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  HeaderContainer,

} from '../AssessmentDetails/styles'
import Button from 'components/Button'
import {
  SelectionRow,
  SelectionColumn,
  ButtonsContainer,
} from '../../Style/assessmentstyles'
import BackArrow from 'components/icons/BackArrow'
import Label from 'components/Form/Label'
import Select from 'components/Select2'
import { InputNumber, Table, DatePicker, Alert, Tooltip } from 'antd'
import moment from 'moment'
import { FormSection, SelectRow,ButtonContainer,  TopSection,
  TopHeader, } from '../../Style/style'
import {
  fetchSubscriptionStates,
  fetchSubscriptionCities,
  fetchSubscriptionInstitutes,
  fetchCorporateStates,
  fetchCorporateCities,
  fetchCorporateCompanies,
  assignSubscription,
  fetchFeatureInstitutes,
  getFeatureAccess,
} from '../../actions'
import { getSingleInstituteDataById } from '../../../Onboarding/Partials/Institutes/Register/actions'
import { getSingleCorporateDataById } from '../../../Onboarding/Partials/Corporates/Register/actions'
import AntdSteps from 'components/AntdSteps'
import { Col, Row, Switch, Checkbox } from 'antd'
import './styles.css'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import SuccessMessage from 'utils/SuccessMessage'
import adminRequest from 'utils/adminRequest'

const { RangePicker } = DatePicker


const AssignSubscription = ({ onClose }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { id } = useParams()
  const location = useLocation()

  // Check if we're navigating from a direct route with entity ID
  const isDirectNavigation = location.pathname.includes('/assessmentAssignSubscription/institute/') || 
                            location.pathname.includes('/assessmentAssignSubscription/corporate/')
  const isInstitutePath = location.pathname.includes('/assessmentAssignSubscription/institute/')
  const isCorporatePath = location.pathname.includes('/assessmentAssignSubscription/corporate/')
  
  // State to track if we're in edit mode (existing data)
  const [isEditMode, setIsEditMode] = useState(false)
  const [instituteData, setInstituteData] = useState(null)
  const [corporateData, setCorporateData] = useState(null)
  const [loadingDisable, setLoadingDisable] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  // Get state from Redux store
  const loading = useSelector(state => state.SubscribedInstitutes.loading)
  const states = useSelector(
    state => state.SubscribedInstitutes.subscriptionStates || []
  )
  const cities = useSelector(
    state => state.SubscribedInstitutes.subscriptionCities || []
  )
  const institutes = useSelector(
    state => state.SubscribedInstitutes.subscriptionInstitutes || []
  )
  // Add selectors for corporate data
  const corporateStates = useSelector(
    state => state.SubscribedInstitutes.corporateStates || []
  )
  const corporateCities = useSelector(
    state => state.SubscribedInstitutes.corporateCities || []
  )
  const companies = useSelector(
    state => state.SubscribedInstitutes.companies || []
  )

  // Local state
  // Set subscription type based on path if direct navigation
  const initialSubscriptionType = isCorporatePath ? 'corporate' : 'college'
  const [subscriptionType, setSubscriptionType] = useState(initialSubscriptionType)
  const [selectedState, setSelectedState] = useState(null)
  const [selectedCity, setSelectedCity] = useState(null)
  const [selectedAssessments, setSelectedAssessments] = useState([])
  // Types that were ticked when the saved subscription loaded. Anything the
  // admin unticks from this list is sent as removedTypes so its row is deleted.
  const [savedAssessments, setSavedAssessments] = useState([])
  const [selectedEntityID, setSelectedEntityID] = useState(isDirectNavigation ? id : null)
  const [entitySearchValue, setEntitySearchValue] = useState('')
  // Skip to step 1 if direct navigation
  const [instCurrent, setInstCurrent] = useState(isDirectNavigation ? 1 : 0)
  const [atsEnabled, setAtsEnabled] = useState(false)
  const [assessmentEnabled, setAssessmentEnabled] = useState(false)
  const [bothEnabled, setBothEnabled] = useState(false)
  // Corporate only: send assessment invites over WhatsApp as well as email.
  const [assessmentManagementEnabled, setAssessmentManagementEnabled] = useState(true)
  const [assessmentCreationEnabled, setAssessmentCreationEnabled] = useState(true)
  const [featureAccessEntityId, setFeatureAccessEntityId] = useState(null)
  const [featureAccessError, setFeatureAccessError] = useState(false)
  const [whatsappNotificationEnabled, setWhatsappNotificationEnabled] = useState(false)
  const [instituteCampusId, setInstituteCampusId] = useState(null)
  // Per-type limits for every selected assessment type, Role_Based included.
  // A limit is mandatory for every selected type unless it is marked unlimited.
  const [typeTokenLimits, setTypeTokenLimits] = useState({}) // { Aptitude: 100, Role_Based: 500, ... }
  const [typeTokensUsed, setTypeTokensUsed] = useState({}) // { Aptitude: 12, ... }
  const [typeUnlimited, setTypeUnlimited] = useState({}) // { Aptitude: true, ... }
  // Contract window for the whole entity. Outside it every assessment type is
  // locked, so it gates far more than the per-type buckets do.
  const [contractRange, setContractRange] = useState(null) // [dayjs, dayjs]
  const isTypeUnlimited = (typeId) => Boolean(typeUnlimited[typeId])

  // Warn the admin when the window they are looking at is already closed —
  // saving it locks the entity immediately.
  const contractExpiry = useMemo(() => {
    const [start, end] = contractRange || []
    const now = moment()
    // Each bound is judged on its own — a half-open range is valid, so an
    // absent bound simply cannot trigger its side of the warning.
    return {
      isExpired: Boolean(end && end.isBefore(now, 'day')),
      isNotStarted: Boolean(start && start.isAfter(now, 'day')),
      startLabel: start ? start.format('DD MMM YYYY') : '',
      endLabel: end ? end.format('DD MMM YYYY') : '',
    }
  }, [contractRange])
  const canSubmit = useMemo(() => {
  if (!isEditMode) {
    if (!atsEnabled && !assessmentEnabled) return false
    if (assessmentEnabled && selectedAssessments.length === 0) return false
  }
  if (
    assessmentEnabled &&
    selectedAssessments.some(
      typeId =>
        !typeUnlimited[typeId] &&
        (!typeTokenLimits[typeId] || typeTokenLimits[typeId] <= 0)
    )
  ) return false
  // The contract period is entirely optional — leaving it blank means no
  // contract gate at all. Only an inverted range blocks the save.
  const [cStart, cEnd] = contractRange || []
  if (cStart && cEnd && !cEnd.isAfter(cStart)) return false
  return true
}, [
  isEditMode,
  atsEnabled,
  assessmentEnabled,
  selectedAssessments,
  typeTokenLimits,
  typeUnlimited,
  contractRange
])
  // Define assessment types — available for both college and corporate
  const assessmentTypes = useMemo(() => {
    return [
      { id: 'Behavior', name: 'Behavior' },
      { id: 'Communication', name: 'Communication' },
      { id: 'Cognitive', name: 'Cognitive' },
      { id: 'Tech_MCQ', name: 'Technical MCQ' },
      { id: 'Tech_CODING', name: 'Technical Coding' },
      { id: 'Aptitude', name: 'Aptitude' },
      { id: 'Role_Based', name: 'Role Based' },
      { id: 'Custom_Assessment', name: 'Custom Assessment' },
      { id: 'AI_Interview', name: 'AI Interview' },
      // AI_Interview_v2 is floated from the v2 wizard and reported in the
      // corporate portal only, so it is a corporate subscription.
      ...(subscriptionType === 'corporate' ? [{ id: 'AI_Interview_v2', name: 'Complete AI Interview' }] : []),
    ]
  }, [subscriptionType])

 

  const menuData = [
    {
      key: 0,
      activeKey: 0,
      title: 'Customer Type',
      heading: 'Customer Type',
    },
    
    {
      key: 1,
      activeKey: 1,
      title: 'Service Type',
      heading: 'Service Type',
    },
  ]


  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <FormSection>
            <div style={{
              marginBottom: '20px',
              padding: '24px',
              backgroundColor: '#fff',
              borderRadius: '8px',
              border: '1px solid #E5E7EB'
            }}>
              <div style={{ marginBottom: '24px' }}>
                <div style={{ fontSize: '16px', fontWeight: '500', color: '#111827', marginBottom: '4px' }}>
                  Choose whether you're configuring access for a Corporate or an Institute
                </div>
                <div style={{ fontSize: '14px', color: '#6B7280' }}>
                  Select the type of organization you want to configure
                </div>
              </div>

              <div style={{ display: 'flex', gap: '16px' }}>
                <div 
                  style={{ 
                    flex: 1,
                    padding: '16px',
                    border: `1px solid ${subscriptionType === 'corporate' ? '#0FB680' : '#E5E7EB'}`,
                    borderRadius: '8px',
                    cursor: 'pointer',
                    backgroundColor: subscriptionType === 'corporate' ? '#F0FDF9' : '#fff'
                  }}
                  onClick={() => 
                    
                    {
                      setSelectedEntityID(null),
                      setSubscriptionType('corporate')}
                    
                  }
                >
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                    <Checkbox 
                      checked={subscriptionType === 'corporate'}
                      style={{ marginRight: '8px' }}
                    />
                    <span style={{ fontSize: '14px', fontWeight: '500', color: '#111827' }}>Corporate</span>
                  </div>
                  <div style={{ fontSize: '14px', color: '#6B7280', marginLeft: '24px' }}>
                    Configure access for a corporate organization
                  </div>
                </div>

                <div 
                  style={{ 
                    flex: 1,
                    padding: '16px',
                    border: `1px solid ${subscriptionType === 'college' ? '#0FB680' : '#E5E7EB'}`,
                    borderRadius: '8px',
                    cursor: 'pointer',
                    backgroundColor: subscriptionType === 'college' ? '#F0FDF9' : '#fff'
                  }}
                  onClick={() => 
                  {
                    setSelectedEntityID(null),
                    setSubscriptionType('college')
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                    <Checkbox 
                      checked={subscriptionType === 'college'}
                      style={{ marginRight: '8px' }}
                    />
                    <span style={{ fontSize: '14px', fontWeight: '500', color: '#111827' }}>Institute</span>
                  </div>
                  <div style={{ fontSize: '14px', color: '#6B7280', marginLeft: '24px' }}>
                    Configure access for an educational institute
                  </div>
                </div>
              </div>
            </div>

            <div style={{ marginTop: '24px' }}>
              <div style={{ 
                fontSize: '16px', 
                fontWeight: '500', 
                color: '#111827', 
                marginBottom: '16px' 
              }}>
                {subscriptionType === 'college' ? 'Institute Details' : 'Corporate Details'}
              </div>

              <SelectRow>
                <div>
                  <Label>
                    {subscriptionType === 'college' ? 'State *' : 'State'}
                  </Label>
                  <Select
                    placeholder="Select State"
                    showSearch={true}
                    OptionData={formattedStates}
                    onChange={handleStateChange}
                    value={selectedState ? selectedState.id : null}
                    valueParam="id"
                    nameParam="name"
                    allowClear={true}
                  />
                </div>
                <div>
                  <Label>{subscriptionType === 'college' ? 'City *' : 'City'}</Label>
                  <Select
                    placeholder="Select City"
                    showSearch={true}
                    OptionData={formattedCities}
                    onChange={handleCityChange}
                    value={selectedCity ? selectedCity.id : null}
                    valueParam="id"
                    nameParam="name"
                    disabled={!selectedState}
                    allowClear={true}
                  />
                </div>
              </SelectRow>

              <SelectRow>
                <div>
                  <Label>{getEntityLabel()} *</Label>
                  <Select
                    placeholder={`Select ${getEntityLabel()}`}
                    showSearch={true}
                    OptionData={filteredEntities}
                    onChange={handleEntitySelect}
                    onSearch={handleEntitySearch}
                    value={selectedEntityID}
                    valueParam="id"
                    nameParam="name"
                    searchValue={entitySearchValue}
                    disabled={subscriptionType === 'college' ? !selectedCity : false}
                    allowClear={true}
                  />
                </div>
              </SelectRow>

            </div>

            
          </FormSection>
        );
      case 1:
        return (
          <FormSection>
            <div style={{
              marginBottom: '20px',
              padding: '24px',
              backgroundColor: '#fff',
              borderRadius: '8px',
              border: '1px solid #E5E7EB'
            }}>
              <div style={{ marginBottom: '15px' }}>
                <div>You can enable access to set up an Application Tracking System (ATS), an Assessment, or both for:</div>
                <div style={{ marginTop: '10px', fontWeight: 'bold' }}>
                {subscriptionType === 'college' ?
                <>
                {instituteData?.name}  {selectedEntityID ? filteredEntities.find(e => e.id === selectedEntityID)?.name : instituteData?.name || ''}, {selectedCity?.name || instituteData?.instituteCampus?.[0]?.city || ''}, {selectedState?.name || instituteData?.instituteCampus?.[0]?.state || ''}
                </>
                :
                <>
               {corporateData?.name} {selectedEntityID ? filteredEntities.find(e => e.id === selectedEntityID)?.name : corporateData?.name || ''}, {selectedCity?.name || corporateData?.city || ''}, {selectedState?.name || corporateData?.state || ''}
                </>
    }
                
                </div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', marginTop: '20px' }}>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'space-between',
                  padding: '15px',
                  border: '1px solid #e8e8e8',
                  borderRadius: '8px',
                  backgroundColor: '#fff'
                }}>
                  <div>
                    <div style={{ fontWeight: '500', fontSize: '15px' }}>Application Tracking System</div>
                    <div style={{ color: '#666', fontSize: '13px', marginTop: '4px' }}>Enable ATS features for this organization</div>
                  </div>
                  <Switch
                    checked={atsEnabled}
                    onChange={(checked) => {
                      setAtsEnabled(checked)
                      if (!checked) setBothEnabled(false)
                    }}
                  />
                </div>

                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'space-between',
                  padding: '15px',
                  border: '1px solid #e8e8e8',
                  borderRadius: '8px',
                  backgroundColor: '#fff'
                }}>
                  <div>
                    <div style={{ fontWeight: '500', fontSize: '15px' }}>Assessments</div>
                    <div style={{ color: '#666', fontSize: '13px', marginTop: '4px' }}>Enable Assessment features for this organization</div>
                  </div>
                  <Switch
                    checked={assessmentEnabled}
                    onChange={(checked) => {
                      setAssessmentEnabled(checked)
                      if (!checked) setBothEnabled(false)
                    }}
                  />
                </div>

                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'space-between',
                  padding: '15px',
                  border: '1px solid #e8e8e8',
                  borderRadius: '8px',
                  backgroundColor: '#fff',
                  marginTop: '10px'
                }}>
                  <div>
                    <div style={{ fontWeight: '500', fontSize: '15px' }}>Enable Both</div>
                    <div style={{ color: '#666', fontSize: '13px', marginTop: '4px' }}>Enable both ATS and Assessment features together</div>
                  </div>
                  <Switch
                    checked={bothEnabled}
                    onChange={handleBothChange}
                  />
                </div>

                {/* Integrated Assessment Configuration and Practice Toggles */}
                {assessmentEnabled && (
                  <div style={{ marginBottom: '5px' }}>
                    <div style={{ fontWeight: '500', fontSize: '15px' }}>Assessment Configuration</div>
                  </div>
                )}
                
                {assessmentEnabled && (
                  <SelectionRow style={{ marginBottom: '5px' }}>
                    <Label>Subscribed Assessment Types *</Label>
                    <SelectionColumn>
                      <Select
                        mode="multiple"
                        placeholder="Select assessment types"
                        style={{ width: '94%' }}
                        onChange={setSelectedAssessments}
                        value={selectedAssessments}
                        OptionData={assessmentTypes}
                        valueParam="id"
                        nameParam="name"
                      />
                    </SelectionColumn>
                  </SelectionRow>
                )}

                <div style={{
                  padding: '15px',
                  border: '1px solid #e8e8e8',
                  borderRadius: '8px',
                  marginBottom: '15px',
                  background: '#fff',
                }}>
                  <label
                    htmlFor="contract-period"
                    style={{ fontWeight: '500', fontSize: '15px', display: 'block', marginBottom: '8px' }}
                  >
                    Contract Period <span style={{ color: '#666', fontWeight: 400 }}>(optional)</span>
                  </label>
                  <div style={{ color: '#666', fontSize: '13px', marginBottom: '12px' }}>
                    Outside this window every assessment type is locked for this{' '}
                    {subscriptionType === 'corporate' ? 'corporate' : 'institute'} —
                    nothing can be assigned or scheduled, and candidates cannot start
                    any assessment, practice included. Attempts already in progress
                    are allowed to finish.
                    <br />
                    Each date is enforced only if you set it. Leave both blank for no
                    contract limit, set only an end date to run until then, or only a
                    start date to open on that day and never expire.
                  </div>
                  <RangePicker
                    id="contract-period"
                    value={contractRange}
                    onChange={setContractRange}
                    format="DD-MM-YYYY"
                    style={{ width: '100%', maxWidth: 360 }}
                    placeholder={['Start (optional)', 'End (optional)']}
                    allowEmpty={[true, true]}
                    allowClear
                  />
                  {contractExpiry.isExpired && (
                    <Alert
                      role="alert"
                      type="error"
                      showIcon
                      style={{ marginTop: 12 }}
                      message={`Contract ended on ${contractExpiry.endLabel}`}
                      description="Everything is locked for this entity until the period is extended."
                    />
                  )}
                  {contractExpiry.isNotStarted && (
                    <Alert
                      role="alert"
                      type="warning"
                      showIcon
                      style={{ marginTop: 12 }}
                      message={`Contract starts on ${contractExpiry.startLabel}`}
                      description="Assessments stay locked until then."
                    />
                  )}
                </div>

                {assessmentEnabled && selectedAssessments.length > 0 && (
                  <div style={{
                    padding: '15px',
                    border: '1px solid #e8e8e8',
                    borderRadius: '8px',
                    marginBottom: '15px',
                    background: '#FBFAFF',
                  }}>
                    <div style={{ fontWeight: '500', fontSize: '15px', marginBottom: '8px' }}>Assessment Limits *</div>
                    <div style={{ color: '#666', fontSize: '13px', marginBottom: '12px' }}>
                      Maximum real attempts (one-time + scheduled + broadcast) each type can consume. Each student attempt consumes 1 token; practice attempts are not counted. A limit is required for every selected type unless it is marked Unlimited. When a type runs out of credits only that type is locked — the rest stay available.
                      {subscriptionType === 'college' && ' Marking Communication or Aptitude Unlimited also gives this institute\'s students practice access for that type.'}
                    </div>
                    <Table
                      size="small"
                      pagination={false}
                      rowKey="id"
                      dataSource={assessmentTypes.filter(t => selectedAssessments.includes(t.id))}
                      columns={[
                        {
                          title: 'Assessment Type',
                          dataIndex: 'name',
                          key: 'name',
                        },
                        {
                          title: 'Unlimited',
                          key: 'unlimited',
                          render: (_, t) => (
                            <Tooltip title={`No credit cap for ${t.name}. Usage is still counted for reporting.`}>
                              <Switch
                                size="small"
                                checked={isTypeUnlimited(t.id)}
                                aria-label={`Unlimited credits for ${t.name}`}
                                onChange={(checked) => {
                                  setTypeUnlimited(prev => ({ ...prev, [t.id]: checked }))
                                  // Clear the now-inert number so the row cannot
                                  // save a stale cap alongside the flag.
                                  if (checked) {
                                    setTypeTokenLimits(prev => ({ ...prev, [t.id]: 0 }))
                                  }
                                }}
                              />
                            </Tooltip>
                          ),
                        },
                        {
                          title: 'Limit',
                          key: 'limit',
                          render: (_, t) => {
                            if (isTypeUnlimited(t.id)) {
                              return <span style={{ color: '#666' }}>Unlimited</span>
                            }
                            const limit = typeTokenLimits[t.id]
                            const invalid = !limit || limit <= 0
                            return (
                              <div>
                                <InputNumber
                                  min={1}
                                  max={100000}
                                  value={limit || undefined}
                                  onChange={(val) => setTypeTokenLimits(prev => ({ ...prev, [t.id]: val || 0 }))}
                                  placeholder="Required"
                                  status={invalid ? 'error' : undefined}
                                  aria-label={`Credit limit for ${t.name}`}
                                  style={{ width: 160 }}
                                />
                                {invalid && (
                                  <div role="alert" style={{ color: '#DC3232', fontSize: 12, marginTop: 4 }}>Required</div>
                                )}
                              </div>
                            )
                          },
                        },
                        {
                          title: 'Used',
                          key: 'used',
                          render: (_, t) => typeTokensUsed[t.id] ?? '—',
                        },
                        {
                          title: 'Remaining',
                          key: 'remaining',
                          render: (_, t) => {
                            if (isTypeUnlimited(t.id)) return '∞'
                            const limit = typeTokenLimits[t.id]
                            const used = typeTokensUsed[t.id]
                            if (!limit || used == null) return '—'
                            return Math.max(limit - used, 0)
                          },
                        },
                      ]}
                    />
                  </div>
                )}

                {(subscriptionType === 'corporate' || subscriptionType === 'college') && (
                  <div className="assessment-creation-access">
                    <div>
                      <Label id="assessment-creation-label">Allow assessment creation</Label>
                      <p id="assessment-creation-help">
                        {subscriptionType === 'corporate'
                          ? 'Allow this corporate to create assessments in the corporate portal. Enabled by default.'
                          : 'Show the Create assessment button in the institute portal. Disabled by default.'}
                      </p>
                      {featureAccessError && <Alert type="error" message="Could not load feature access. Reload this page before saving." />}
                    </div>
                    <Switch
                      aria-labelledby="assessment-creation-label"
                      aria-describedby="assessment-creation-help"
                      checked={assessmentCreationEnabled}
                      disabled={featureAccessEntityId !== selectedEntityID}
                      onChange={setAssessmentCreationEnabled}
                    />
                  </div>
                )}

                {subscriptionType === 'corporate' && (
                  <div className="assessment-creation-access">
                    <div>
                      <Label id="assessment-management-label">Allow assessment management</Label>
                      <p id="assessment-management-help">Show the Manage assessment settings in the corporate portal. Enabled by default.</p>
                    </div>
                    <Switch
                      aria-labelledby="assessment-management-label"
                      aria-describedby="assessment-management-help"
                      checked={assessmentManagementEnabled}
                      disabled={featureAccessEntityId !== selectedEntityID}
                      onChange={setAssessmentManagementEnabled}
                    />
                  </div>
                )}

                {assessmentEnabled && subscriptionType === 'corporate' && (
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '15px',
                    border: '1px solid #e8e8e8',
                    borderRadius: '8px',
                    backgroundColor: '#fff',
                    marginBottom: '15px'
                  }}>
                    <div>
                      <div style={{ fontWeight: '500', fontSize: '15px' }}>WhatsApp Notifications</div>
                      <div style={{ color: '#666', fontSize: '13px', marginTop: '4px' }}>
                        Also send assessment invites to candidates over WhatsApp. Email is always sent.
                      </div>
                    </div>
                    <Switch
                      checked={whatsappNotificationEnabled}
                      onChange={setWhatsappNotificationEnabled}
                    />
                  </div>
                )}

              </div>
            </div>



            {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '24px' }}>
              <Button
                type="default"
                onClick={() => setInstCurrent(instCurrent - 1)}
              >
                Back
              </Button>
              <Button
                type="primary"
                onClick={handleConfirm}
                loading={loading}
                disabled={!isStepValid(instCurrent)}
              >
                Confirm
              </Button>
            </div> */}
          </FormSection>
        );
      default:
        return null;
    }
  };

  // Fetch appropriate states and initial data on component mount or subscription type change
  useEffect(() => {
    if (subscriptionType === 'college') {
      dispatch(fetchSubscriptionStates())
    } else {
      dispatch(fetchSubscriptionStates())
      // For corporate, we also fetch all companies immediately
      dispatch(fetchCorporateCompanies('','',true)) // Empty string means get all companies
    }

    // Reset selections when changing entity type
    setSelectedState('')
    setSelectedCity('')
   // setSelectedEntityID(null)
    setEntitySearchValue('')
  }, [dispatch, subscriptionType])
  
  // Fetch institute data if we have a direct navigation with ID
  useEffect(() => {
    fetchInstitute()
  }, [dispatch, id, isInstitutePath])

  useEffect(() => {
    fetchCorporate()
  }, [dispatch, id, isCorporatePath])

  const fetchCorporate = async () => {
    if (isCorporatePath && id) {
      setIsEditMode(true)
      let response =  await dispatch(getSingleCorporateDataById(id))
            if (response) {
              const data = response?.data?.data;
              setCorporateData(data);
              if (response?.data?.data) {
                const subscription = response?.data?.data;
                
                // Set the access level properly
                if (subscription.accessLevel) {
                  if (subscription.accessLevel === 3) {
                    setAtsEnabled(true);
                    setAssessmentEnabled(true);
                    setBothEnabled(true);
                  } else if (subscription.accessLevel === 2) {
                    setAssessmentEnabled(true);
                    setAtsEnabled(false);
                  } else if (subscription.accessLevel === 1) {
                    setAtsEnabled(true);
                    setAssessmentEnabled(false);
                  }
                }
                if(subscription?.subscriptionType?.length > 0){
                  setSelectedAssessments(subscription?.subscriptionType)
                  setSavedAssessments(subscription?.subscriptionType)
                }
              }
            }
            // Feature-access flags live in admin-node (admin.feature_config),
            // not on the corporate record, so they are fetched separately.

          }
        }

const fetchInstitute = async () => {
  if (isInstitutePath && id) {
    setIsEditMode(true)
    let response =  await dispatch(getSingleInstituteDataById(id))
          if (response) {
            const data = response?.data?.data;
            setInstituteData(data);
            // Find the campus ID from the institute data
            if (data.instituteCampus && data.instituteCampus.length > 0) {
              const campusId = data.instituteCampus[0].id;
              setInstituteCampusId(data?.campusId);
             setSelectedEntityID(data?.id)
              setSubscriptionType('college')
              

              
              // Set city and state from institute data
              if (data.instituteCampus[0].city) {
                setSelectedCity({
                  id: data.instituteCampus[0].cityId,
                  name: data.instituteCampus[0].city
                });
              }
              
              if (data.instituteCampus[0].state) {
                setSelectedState({
                  id: data.instituteCampus[0].stateId,
                  name: data.instituteCampus[0].state
                });
              }
              
              // If there's a subscription, check if there are already practice settings
              if (data.instituteCampus[0].instituteSubscription) {
                const subscription = data.instituteCampus[0].instituteSubscription;
                
                // Set the access level properly
                if (subscription.accessLevel) {
                  if (subscription.accessLevel === 3) {
                    setAtsEnabled(true);
                    setAssessmentEnabled(true);
                    setBothEnabled(true);
                  } else if (subscription.accessLevel === 2) {
                    setAssessmentEnabled(true);
                    setAtsEnabled(false);
                  } else if (subscription.accessLevel === 1) {
                    setAtsEnabled(true);
                    setAssessmentEnabled(false);
                  }
                }
                if(subscription?.subscriptionType?.length > 0){
                  setSelectedAssessments(subscription?.subscriptionType)
                  setSavedAssessments(subscription?.subscriptionType)
                }
              }
            }
          }
        
    }
}
  // Prefetch existing quotas for every currently-selected type (Role_Based
  // included), so limits are pre-filled and current usage is shown on revisit.
  // Works for both institutes and corporates (same endpoint, different param).
  useEffect(() => {
    // Runs whenever an entity is picked, even with no types selected yet — the
    // same response carries the contract window, which applies entity-wide.
    if (!selectedEntityID) return
    const norm = (s) => (s || '').toLowerCase().replace(/[\s-]+/g, '_')
    const fetchAll = async () => {
      try {
        const res = await adminRequest.get('/assessment/getInstituteSubscriptionQuota', {
          params: subscriptionType === 'corporate'
            ? { corporate_id: selectedEntityID }
            : { institute_id: selectedEntityID }
        })
        const quotas = res?.data?.data?.quotas || []
        const limits = {}
        const used = {}
        const unlimited = {}
        for (const t of assessmentTypes) {
          const q = quotas.find(x => norm(x.typeName) === norm(t.id))
          if (!q) continue
          if (q.tokenLimit != null && q.tokenLimit > 0) limits[t.id] = q.tokenLimit
          if (q.tokensUsed != null) used[t.id] = q.tokensUsed
          if (q.isUnlimited) unlimited[t.id] = true
        }
        if (Object.keys(limits).length) setTypeTokenLimits(prev => ({ ...limits, ...prev }))
        if (Object.keys(used).length) setTypeTokensUsed(used)
        if (Object.keys(unlimited).length) setTypeUnlimited(prev => ({ ...unlimited, ...prev }))

        // Pre-fill the saved contract window so an edit shows the real period
        // instead of an empty picker that looks like "no contract". Either
        // bound may be absent, so each slot is filled independently.
        const contract = res?.data?.data?.contract
        if (contract?.startDate || contract?.endDate) {
          setContractRange(prev => prev || [
            contract.startDate ? moment(contract.startDate) : null,
            contract.endDate ? moment(contract.endDate) : null,
          ])
        }
      } catch (e) {
        console.warn('[AssignSubscription] Failed to fetch per-type quotas:', e.message)
      }
    }
    fetchAll()
  }, [selectedEntityID, subscriptionType, selectedAssessments, assessmentTypes])

  // Fetch cities when state changes
  useEffect(() => {
    if (subscriptionType === 'college' && !selectedState) return
    if (subscriptionType === 'corporate' && !selectedState) {
      // For corporate, if state is cleared, we still want to fetch all companies
      dispatch(fetchCorporateCompanies('','',true))
      return
    }

    if (subscriptionType === 'college') {
      dispatch(fetchSubscriptionCities(selectedState))
    } else {
      dispatch(fetchSubscriptionCities(selectedState))
    }

    setSelectedCity('')
   // setSelectedEntityID(null)
    setEntitySearchValue('')
  }, [selectedState, dispatch, subscriptionType])

  // Fetch entities when city changes
  useEffect(() => {
    if (subscriptionType === 'college' && !selectedCity) return

    if (subscriptionType === 'college') {
      // //console.log(
      //   'Fetching subscription institutes...',
      //   selectedCity,
      //   selectedState
      // )
      dispatch(fetchSubscriptionInstitutes(selectedCity, selectedState,true))
    } else {
      // For corporate, fetch companies based on city (can be empty string)
      // //console.log(
      //   'Fetching subscription corporate...',
      //   selectedCity,
      //   selectedState
      // )
      dispatch(fetchCorporateCompanies(selectedCity, selectedState,true))
    }

   // setSelectedEntityID(null)
    setEntitySearchValue('')
  }, [selectedCity, dispatch, subscriptionType])

  const handleStateChange = value => {
    const stateObject =
      formattedStates.find(state => state.id === value) || null
    setSelectedState(stateObject)
    setSelectedEntityID(null)
  }

  const handleCityChange = value => {
    const cityObject = formattedCities.find(city => city.id === value) || null
    setSelectedCity(cityObject)
    setSelectedEntityID(null)
    // For corporate, immediately update companies when city changes
    if (subscriptionType === 'corporate') {
      dispatch(fetchCorporateCompanies(selectedCity, selectedState,true))
    }
  }

  useEffect(() => {
    const isCorporate = subscriptionType === 'corporate'
    if ((!isCorporate && subscriptionType !== 'college') || !selectedEntityID) return
    let cancelled = false
    setFeatureAccessEntityId(null)
    setFeatureAccessError(false)
    dispatch(getFeatureAccess(selectedEntityID, isCorporate ? 'corporate' : 'institute')).then(features => {
      if (cancelled) return
      if (typeof features?.ASSESSMENT_CREATION !== 'boolean' || (isCorporate && typeof features?.ASSESSMENT_MANAGEMENT !== 'boolean')) {
        setFeatureAccessError(true)
        return
      }
      setAssessmentCreationEnabled(features.ASSESSMENT_CREATION)
      if (!isCorporate) {
        setFeatureAccessEntityId(selectedEntityID)
        return
      }
      setAssessmentManagementEnabled(features.ASSESSMENT_MANAGEMENT)
      setWhatsappNotificationEnabled(Boolean(features.WHATSAPP_NOTIFICATION))
      setFeatureAccessEntityId(selectedEntityID)
    })
    return () => { cancelled = true }
  }, [dispatch, selectedEntityID, subscriptionType])

  const handleEntitySelect = (value, option) => {
    setInstituteCampusId(option?.id)
    setSelectedEntityID(value)
    // Find the selected entity
    const selectedEntity = formattedEntities.find(entity => entity.id === value)

    // Update the search value with the selected entity name
    if (selectedEntity) {
      setEntitySearchValue(selectedEntity.name)
    }
    

  }

  const handleEntitySearch = value => {
    setEntitySearchValue(value)
  }

  const handleBothChange = (checked) => {
    setBothEnabled(checked)
    if (checked) {
      setAtsEnabled(true)
      setAssessmentEnabled(true)
    } else {
      setAtsEnabled(false)
      setAssessmentEnabled(false)
    }
  }

  useEffect(() => {
    setBothEnabled(atsEnabled && assessmentEnabled)
  }, [atsEnabled, assessmentEnabled])

  const formattedStates = React.useMemo(() => {
    const sourceStates = states

    return (
      sourceStates?.map(state => ({
        id: state._id,
        name: state.name,
      })) || []
    )
  }, [states, subscriptionType])

  const formattedCities = React.useMemo(() => {
    const sourceCities = cities
    return (
      sourceCities?.map(city => ({
        id: city._id,
        name: city.name,
      })) || []
    )
  }, [cities, subscriptionType])

  const formattedEntities = React.useMemo(() => {
    if (subscriptionType === 'college') {
      return (
        institutes?.map(institute => ({
          id: institute.id,
          name: institute.name,
          campus_id: institute.instituteCampus[0].id,
        })) || []
      )
    } else {
      return (
        companies?.map(company => ({
          id: company.id,
          name: company.name,
        })) || []
      )
    }
  }, [institutes, companies, subscriptionType])

  // Filter entities based on search input
  const filteredEntities = entitySearchValue
    ? formattedEntities.filter(entity =>
        entity.name.toLowerCase().includes(entitySearchValue.toLowerCase())
      )
    : formattedEntities


  const handleConfirm = () => {
    setLoadingDisable(true)
    // Use instituteCampusId instead of selectedEntityID for institutes
    const entityIdToUse = selectedEntityID;
    console.log(entityIdToUse)
    // Validation: If assessment is enabled, at least one assessment type must be selected
    if (assessmentEnabled && (!selectedAssessments || selectedAssessments.length === 0)) {
      setLoadingDisable(false)
      alert('Please select at least one assessment type.');
      return
    }
    if (selectedEntityID && (atsEnabled || assessmentEnabled || isDirectNavigation)) {
      // Calculate access level based on enabled features
      // 1: ATS, 2: Assessment, 3: Both
      let accessLevel;
      if (atsEnabled && assessmentEnabled) {
        accessLevel = 3; // Both
      } else if (atsEnabled) {
        accessLevel = 1; // ATS only
      } else if (assessmentEnabled) {
        accessLevel = 2; // Assessment only
      }
      else{
        accessLevel = 0; // None
      }

      // Practice follows Unlimited (enforced server-side), so no practice
      // degree sets are sent; an empty list clears any legacy saved sets.
      const practiceDegreeSets = [];

      // Per-type limits: every selected type is mandatory unless it is
      // explicitly marked unlimited.
      if (
        assessmentEnabled &&
        selectedAssessments.some(
          typeId =>
            !typeUnlimited[typeId] &&
            (!typeTokenLimits[typeId] || typeTokenLimits[typeId] <= 0)
        )
      ) {
        setLoadingDisable(false)
        alert('Please enter an assessment limit for every selected type, or mark it Unlimited.')
        return
      }
      const tokenLimitsPayload = {}
      const unlimitedTypesPayload = []
      selectedAssessments.forEach(typeId => {
        if (typeUnlimited[typeId]) {
          unlimitedTypesPayload.push(typeId)
          return
        }
        const lim = typeTokenLimits[typeId]
        if (lim && lim > 0) tokenLimitsPayload[typeId] = lim
      })

      const [contractStart, contractEnd] = contractRange || []
      if (contractStart && contractEnd && !contractEnd.isAfter(contractStart)) {
        setLoadingDisable(false)
        alert('Contract end date must be after the start date.')
        return
      }
      // Each bound is sent only if set, so the API stores (and the gate then
      // enforces) exactly the ones the admin chose. Sent as the full inclusive
      // day in the admin's local zone — a contract ending "16 Aug" must stay
      // open all of 16 Aug.
      const contractDates = {
        ...(contractStart
          ? { contractStartDate: contractStart.clone().startOf('day').toISOString() }
          : {}),
        ...(contractEnd
          ? { contractEndDate: contractEnd.clone().endOf('day').toISOString() }
          : {}),
      }

      dispatch(
        assignSubscription(
          selectedEntityID,
          // A college never gets Complete AI Interview, even if it was ticked before switching type.
          subscriptionType === 'corporate' ? selectedAssessments : selectedAssessments.filter(type => type !== 'AI_Interview_v2'),
          subscriptionType,
          accessLevel,
          practiceDegreeSets,
          isEditMode ? id : null,
          undefined,
          tokenLimitsPayload,
          // Corporate-only feature flag; the API ignores it for colleges.
          subscriptionType === 'corporate' ? whatsappNotificationEnabled : undefined,
          unlimitedTypesPayload,
          contractDates,
          subscriptionType === 'corporate' || subscriptionType === 'college' ? assessmentCreationEnabled : undefined,
          subscriptionType === 'corporate' ? assessmentManagementEnabled : undefined,
          savedAssessments.filter(type => !selectedAssessments.includes(type))
        )
      )
        .then(() => {
         // onClose()
         SuccessMessage('Subscription assigned successfully')
         navigate('/assessmentAccess')
         setLoadingDisable(false)
        })
        .catch(error => {
          console.error('Error assigning subscription:', error)
          setLoadingDisable(false)
        })
    } else {
      console.error('Missing required data:', {
        selectedEntityID,
        instituteCampusId,
        atsEnabled,
        assessmentEnabled
      });
    }
  }
  const handleConfirm1 = () => { 
    setInstCurrent(1)
  }

  // Get the correct title based on subscription type
  const getTitle = () => {
    return subscriptionType === 'college'
      ? 'Assign Subscription to College'
      : 'Assign Subscription to Corporate'
  }

  // Get the correct entity label based on subscription type
  const getEntityLabel = () => {
    return subscriptionType === 'college' ? 'College' : 'Company'
  }

  // Determine if the form is valid for submission
  const isStepValid = () => {
    switch (instCurrent) {
      case 0:
        // For direct navigation paths, always return true as we'll skip this step
        if (isDirectNavigation) return true;
        if (subscriptionType === 'corporate') {
        return selectedState && selectedCity && selectedEntityID;
      }
        return subscriptionType === 'corporate' || (selectedState && selectedCity && selectedEntityID)
      case 1:
        // If assessment is enabled, ensure at least one assessment type is selected
        if (assessmentEnabled && (!selectedAssessments || selectedAssessments.length === 0)) return false;
        // For direct navigation, still enforce the above validation and at least one service enabled
        if (isDirectNavigation) return (atsEnabled || assessmentEnabled)
        return atsEnabled || assessmentEnabled // At least one service must be enabled
      default:
        return false;
    }
  }

  return (
    <>
      <TopSection>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <BackArrow 
            style={{ marginRight: '10px', cursor: 'pointer' }} 
            onClick={() => navigate('/assessmentAccess')} 
          />
          <TopHeader>Give feature access</TopHeader>
        </div>
        <ButtonContainer>
  {/* Back button */}
  {(instCurrent > 0 && !isDirectNavigation) || (isDirectNavigation && instCurrent > 1) ? (
    <Button.Secondary
      text="Back"
      onClick={() => setInstCurrent(instCurrent - 1)}
      style={{ marginRight: '12px' }}
      disabled={loadingDisable}  // disable during Submit loading
    />
  ) : null}

  {/* Next / Submit button */}
  {instCurrent === 0 ? (
    <Button.Primary
      text="Next"
      onClick={() => setInstCurrent(instCurrent + 1)}
      disabled={!isStepValid() || loadingDisable}
    />
  ) : (
    <Button.Primary
      text="Submit"
      onClick={!loadingDisable ? handleConfirm : undefined}
      loading={loadingDisable}
      style={{ opacity: loadingDisable ? 1 : undefined }}
      disabled={!canSubmit || loadingDisable || ((subscriptionType === 'corporate' || subscriptionType === 'college') && featureAccessEntityId !== selectedEntityID)}
    />
  )}
</ButtonContainer>

      </TopSection>

      <Row>
        <Col span={4}>
          <AntdSteps
            style={{marginTop: '25px'}}
            steps={menuData}
            current={instCurrent}
            // Disable Customer Type step if coming from direct navigation
            disabled={isDirectNavigation ? [0] : []}
          />
        </Col>
        <Col span={20}>
          {renderStepContent(instCurrent)}
        </Col>
      </Row>
   
    </>
  )
}

export default AssignSubscription
